// Smart Daara - Physical school: my published report cards (student/parent)
import React, { useEffect, useState } from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { gradesAPI, downloadBlob } from '../../lib/api';
import { Card, CardContent } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Badge } from '../../components/ui/badge';
import { FileDown, Award } from 'lucide-react';
import { toast } from 'sonner';

export default function MyReportCards() {
  const { language } = useLanguage();
  const fr = language === 'fr';
  const [cards, setCards] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    gradesAPI.myReportCards().then((r) => setCards(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const dl = async (c) => {
    try {
      const res = await gradesAPI.reportCardPdf(c.class_id, c.period_id, c.student_user_id, language);
      downloadBlob(res.data, `bulletin_${c.period_name.replace(/ /g, '_')}.pdf`);
    } catch (e) { toast.error(fr ? 'Téléchargement impossible' : 'Download failed'); }
  };

  if (loading) return <div className="flex justify-center p-12"><div className="animate-spin w-8 h-8 border-2 border-emerald-600 border-t-transparent rounded-full" /></div>;

  return (
    <div className="space-y-5" data-testid="my-report-cards-page">
      <h1 className="text-2xl font-outfit font-bold text-slate-900">{fr ? 'Mes bulletins' : 'My report cards'}</h1>
      <div className="grid sm:grid-cols-2 gap-3">
        {cards.map((c) => (
          <Card key={c.id} className="border-0 shadow-sm">
            <CardContent className="p-4 flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-emerald-50 rounded-xl flex items-center justify-center">
                  <Award className="w-5 h-5 text-emerald-700" />
                </div>
                <div>
                  <p className="font-medium">{c.period_name} — {c.class_name}</p>
                  <p className="text-xs text-slate-400">{c.student_name} · <Badge className="bg-emerald-100 text-emerald-700 text-[10px]">{fr ? 'Publié' : 'Published'}</Badge> · v{c.version}</p>
                </div>
              </div>
              <Button size="sm" className="bg-emerald-700" onClick={() => dl(c)} data-testid={`dl-report-${c.id}`}>
                <FileDown className="w-4 h-4 mr-1" />PDF
              </Button>
            </CardContent>
          </Card>
        ))}
      </div>
      {cards.length === 0 && <p className="text-slate-400 text-sm text-center py-8">{fr ? 'Aucun bulletin publié pour le moment' : 'No published report cards yet'}</p>}
    </div>
  );
}
